module.exports = __webpack_public_path__ + "static/media/icon_calculator.54fff030.svg";